package utils

import androidx.lifecycle.ViewModel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

interface UiState
interface UiAction

abstract class BaseViewModel<State : UiState, Action : UiAction>() : ViewModel() {

    private val _state: MutableStateFlow<State> by lazy { MutableStateFlow(initState()) }
    val state: StateFlow<State> by lazy { _state.asStateFlow() }

    val stateValue: State
        get() = state.value

    abstract fun initState(): State

    abstract fun onAction(action: Action)

    fun updateState(modify: State.() -> State) {
        _state.update { it.modify() }
    }
}
